module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user_forgetpassword"
  }, [(!_vm.fgStatus) ? _c('form', {
    staticClass: "form-forgetpassword"
  }, [_c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "請輸入當初註冊的信箱"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.comfirm) ? _c('div', {
    staticClass: "warning"
  }, [_vm._v("信箱格式錯誤")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-submit",
    on: {
      "click": _vm.submitEmail
    }
  }, [_vm._v("送出")])]) : _vm._e(), _vm._v(" "), (_vm.fgStatus === 'success') ? _c('div', {
    staticClass: "submit-success"
  }, [_c('h3', [_vm._v("密碼已寄送到 " + _vm._s(_vm.email))]), _vm._v(" "), _c('p', [_vm._v("已寄發重設密碼連結信件到信箱，請盡快打開信件進行後續設定！")])]) : _vm._e(), _vm._v(" "), (_vm.fgStatus === 'fail') ? _c('div', {
    staticClass: "submit-fail"
  }, [_c('p', [_vm._v("網頁錯誤，請重新整理再試一次。")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c0660d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/Forgetpassword.vue
// module id = 136
// module chunks = 18